import {useMemo} from 'react';

import {DataFrame} from 'data-frames/DataFrameTypes';
import {DataFrameValueAccessor} from 'data-frames/util/createAccessors';
import filterRows from 'data-frames/util/filterRows';

import useSeriesExcludedState, {UseSeriesExcludedState} from './useSeriesExcludedState';

interface UseSeriesExcludedWithDataFrameState extends UseSeriesExcludedState {
  filteredDataFrame: DataFrame;
}

export function useSeriesExcludedWithDataFrameState(
  dataFrame: DataFrame,
  seriesAccessor: DataFrameValueAccessor<string>
): UseSeriesExcludedWithDataFrameState {
  const {excludedSeries, toggleExcludedSeries} = useSeriesExcludedState();
  const filteredDataFrame = useMemo(
    () => filterRows(dataFrame, (row) => !excludedSeries.has(seriesAccessor(row))),
    [excludedSeries, dataFrame, seriesAccessor]
  );

  return {
    excludedSeries,
    filteredDataFrame,
    toggleExcludedSeries,
  };
}
